module.exports = __webpack_public_path__ + "static/media/tree.a498b76b.png";